export class TipoTarefa {
  id: number;
  descricao: string;
  valorBase: number;
  diasFinalizacao: number;
}
